import * as React from 'react';
import { makeStyles, Step, StepLabel, Stepper } from '@material-ui/core';
import clsx from 'clsx';
import { alpha } from '@material-ui/core/styles/colorManipulator';
import './VerticalStepper.scss'

export default function VerticalStepper(props) {
  const { steps, stepIcons } = props;
  const useStyles = makeStyles((theme) => ({
    root: {
      backgroundColor: alpha(theme.palette.primary.main, 0.1),
      color: theme.palette.primary.main,
      padding: 8,
      borderRadius: '50%',
    },
  }));

  const CustomStepIcon = (props) => {
    const classes = useStyles();
    const { active } = props;

    return (
      <div
        className={clsx(classes.root, {
          [classes.active]: active,
        })}
      >
        {stepIcons[String(props.icon)]}
      </div>
    );
  };

  return (
    <div className="verticalStepper">
        <Stepper className="px-0" activeStep={0} orientation="vertical">
          {steps.map((steps) => (
            <Step key={steps.label}>           
              <StepLabel StepIconComponent={CustomStepIcon}>{steps.label}</StepLabel>       
            </Step>
          ))}
        </Stepper>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Common/VerticalStepper.js